import { configureStore } from "@reduxjs/toolkit";
import appReducer from "./slices/appSlice";
import userReducer from "./slices/userState";
import authReducer from "./slices/authState";
import countReducer from "./slices/countState";
import categoryReducer from "./slices/categoryState";
import whishlistReducer from "./slices/whishlistState";
import supportTicketReducer from "./slices/supportTicketState";
import homeReducer from "./slices/homeState";

export const store = configureStore({
  reducer: {
    app: appReducer,
    userState: userReducer,
    authState: authReducer,
    countState: countReducer,
    categoryState: categoryReducer,
    whishlistState: whishlistReducer,
    supportTicketState: supportTicketReducer,
    homeState: homeReducer,
  },
});

export const getAppState = (state) => state.app;
